import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { MapPin, Mail, Phone } from "lucide-react";

/**
 * Simplified footer per SmartValue-style spec:
 * Only company brand, registered + branch address, contact channels, and a
 * copyright strip. No shop / opportunity / legal columns (those live under the
 * dedicated pages in the navbar).
 */
export default function Footer() {
  return (
    <footer className="bg-royal text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo light />
          <p className="text-sm text-white/60 mt-6 leading-relaxed">
            Samara Wiz Pvt Ltd — a diversified Health, Education and Personal Care
            company registered in India.
          </p>
        </div>
        <div>
          <h4 className="text-gold text-xs tracking-[0.3em] uppercase mb-4">Registered Office</h4>
          <div className="flex items-start gap-2 text-sm text-white/80 leading-relaxed">
            <MapPin size={14} className="mt-1 shrink-0 text-gold" />
            <span>
              Samara Wiz Pvt Ltd<br />
              Vrindavan Garden House No. 47, Khasra 223,<br />
              Sector 16B, Ghaziabad – 201009,<br />
              Uttar Pradesh, India
            </span>
          </div>
        </div>
        <div>
          <h4 className="text-gold text-xs tracking-[0.3em] uppercase mb-4">Branch Office</h4>
          <div className="flex items-start gap-2 text-sm text-white/80 leading-relaxed">
            <MapPin size={14} className="mt-1 shrink-0 text-gold" />
            <span>
              Samara Wiz Pvt Ltd<br />
              SANKALP, Kabir Market, Near Loyola School,<br />
              Industrial Estate Road, Kurji,<br />
              Patna – 800010, Bihar, India
            </span>
          </div>
          <div className="mt-4 space-y-2 text-sm text-white/75">
            <div className="flex items-center gap-2"><Mail size={13} className="text-gold" /> support@samarawiz.com</div>
            <div className="flex items-center gap-2"><Phone size={13} className="text-gold" /> +91 98601 28999</div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-white/40 flex flex-col md:flex-row justify-between gap-3">
          <span>© {new Date().getFullYear()} Samara Wiz Pvt Ltd. All rights reserved.</span>
          <span className="flex gap-3">
            <Link to="/legal/terms" className="hover:text-gold">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-gold">Privacy</Link>
            <Link to="/legal/refund" className="hover:text-gold">Refund</Link>
            <Link to="/grievance" className="hover:text-gold">Grievance</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
